import { getPortalCodeFromUrl } from "../Utils/getPortalCodeFromUrl";
import { useEffect } from 'react';

/**
 * saas页面标题hook
 * @param {string} [title=''] 功能名｜动态名
 * @param {*} [portalData={}] 机构详情
 */
var useSaasTitle = function useSaasTitle() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var portalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  useEffect(function () {
    var alias = getPortalCodeFromUrl();
    //@ts-ignore
    var _ref = (portalData === null || portalData === void 0 ? void 0 : portalData[alias]) || {},
      organizationName = _ref.organizationName,
      shortName = _ref.shortName;
    var orgName = shortName || organizationName;
    document.title = title + (orgName ? "-".concat(orgName) : '');
  }, [title, portalData]);
};
export default useSaasTitle;